module.exports = __webpack_public_path__ + "media/images/logo-0f3c493f3a830a7023b96f11b254c0b9.png";